import React, { FC, useContext } from 'react'
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Button } from 'reactstrap';
import FilterPanel from './FilterPanel';
import { DataContext } from 'hooks/HeaderContext';

interface MobileFilterPanelProps {
    showMobileFilterPanel: boolean;
    toggleMobileFilterPanel(): void;
}

const MobileFilterPanel: FC<MobileFilterPanelProps> = ({
    showMobileFilterPanel, toggleMobileFilterPanel,
}) => {

    const {
        filteredDogsList,
        removeAllFilters,
    } = useContext(DataContext);

    const closePanel = () => {
        removeAllFilters();
        toggleMobileFilterPanel();
    }


    return (
        <Offcanvas
            toggle={toggleMobileFilterPanel}
            isOpen={showMobileFilterPanel}
            direction='start'
            className="filter-offcanvas w-100"
        >
            <OffcanvasHeader
                toggle={() => closePanel()}
                className="mb-0 d-flex align-items-center font-primary text-center w-100 ms-auto me-auto"
            >
                <span>{filteredDogsList?.length + ' ' + (filteredDogsList?.length === 1 ? 'Dog' : 'Dogs')}</span>
            </OffcanvasHeader>
            <OffcanvasBody className='d-flex flex-column filter-body p-0'>
                <div id="searchPanelContent" className="px-3 pt-3 overflow">
                    <FilterPanel />
                </div>
                <footer className='footer'>
                    <div className="d-flex">
                        <Button outline color='secondary' className='p-3 col-4 font-primary fw-bold bg-light'
                            onClick={_ => removeAllFilters()}
                        >
                            Reset
                        </Button>
                        <Button outline color='secondary' className='p-3 col-8 font-primary fw-bold bg-light'
                            onClick={_ => toggleMobileFilterPanel()}
                        >
                            Apply Filters
                        </Button>
                    </div>
                </footer>
            </OffcanvasBody>
        </Offcanvas>
    )
}

export default MobileFilterPanel;